var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../../lib/interactjs/dist/interact", "../LayoutDesigner/LayoutElement"], function (require, exports, interact, LayoutElement_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfigurationContentElement = (function (_super) {
        __extends(ConfigurationContentElement, _super);
        function ConfigurationContentElement(width, height, x, y, id, parent) {
            var _this = _super.call(this, width, height, x, y, id, parent) || this;
            _this.nameElement = _this.element.append('<div id="name" style="padding:4px;overflow:hidden;font-size:11px" class="BlackTextShadow"></div>');
            _this.ClassName = "ConfigContentRect";
            return _this;
        }
        ConfigurationContentElement.prototype.ApplyTouch = function () {
            if (this.ignoreTapInteraction)
                return;
            interact("#" + this.id)
                .on('tap', this.TouchElement.bind(this));
        };
        ConfigurationContentElement.prototype.TouchElement = function (event) {
            console.log("TouchElement CE: " + this.id);
            event.preventDefault();
            var evt = event ? event : window.event;
            if (evt.stopPropagation)
                evt.stopPropagation();
            if (evt.cancelBubble != null)
                evt.cancelBubble = true;
            this.FireEvent("ContentElementTouched", { element: this });
        };
        return ConfigurationContentElement;
    }(LayoutElement_1.LayoutElement));
    exports.ConfigurationContentElement = ConfigurationContentElement;
});
//# sourceMappingURL=ConfigurationContentElement.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/ConfigurationDesigner/ConfigurationContentElement.js
// module id = 388
// module chunks = 0